export default __webpack_public_path__ + "static/media/play.a5398495.svg";